export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const STORAGE_KEY = "papicoo_admin_pwd";
export const fmtEur = (n) => `${(Number(n) || 0).toFixed(2)} €`;
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";
